import actionTypes from 'redux/actions/actionTypes'

const defaultState = {
	entityUID: '',
	currentSlideIndex: 0,
	slides: [],
}

function googleSlidesActivitySaved(state, action) {
	const newSlide = {
		slideExternalId: action.slideExternalId,
		icon: action.icon,
		slideTypeId: action.slideTypeId,
		isNearpodSlide: true,
	}

	return slideListObtained(state, newSlide)
}

function entityUidObtained(state, entityUID) {
	return {
		...state,
		entityUID,
	}
}

function slideListObtained(state, currentSlide) {
	const newState = {
		...state,
		slides: [
			...state.slides,
			currentSlide,
		],
	}

	newState.currentSlideIndex = newState.slides.length -1
	return newState

}

function changeCurrentSlideIndex(state, currentSlideIndex) {
	const newState = {...state}
	newState.currentSlideIndex = currentSlideIndex
	return newState
}

const externalReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.GOOGLE_SLIDES_INITIALIZE_SUCCESS:
			return entityUidObtained(state, action.response.result.data.entityUID)
		case actionTypes.GOOGLE_SLIDES_EDIT_LESSON_SUCCESS:
			return entityUidObtained(state, action.response.entity.data.entityUID)
		case actionTypes.GOOGLE_SLIDES_GET_SLIDE_TYPE_SUCCESS:
			return slideListObtained(state, action.currentSlide)
		case actionTypes.GOOGLE_SLIDES_CHANGE_CURRENT_SLIDE_INDEX:
			return changeCurrentSlideIndex(state, action.currentSlideIndex)
		case actionTypes.GOOGLE_SLIDES_ACTIVITY_SAVED_FINISHED:
			return googleSlidesActivitySaved(state, action)
		default: return state
	}
}

export default externalReducer
